import React, { useEffect, useMemo, useRef, useState } from "react";
import _ from "lodash";
import {
  AppBar as MUIAppBar,
  Box,
  Grow,
  Hidden,
  IconButton,
  Link,
  makeStyles,
  Typography
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { getMenuItems } from "utils/OGN";
import OGNMenu from "./OGNMenu/OGNMenu";
import UserMenu from "./UserMenu/UserMenu";

const defaultSiteMenu = [
  ["Open Gaming Network", "https://www.opengamingnetwork.com"],
  ["-", ""],
  ["d20pfsrd.com", "https://www.d20pfsrd.com"],
  ["5esrd.com", "https://www.5esrd.com"],
  ["-", ""],
  ["OGN Articles", "https://articles.opengamingnetwork.com"],
  ["Forum", "https://forum.opengamingnetwork.com"]
];
const defaultSecondaryTopHeadings = [
  ["Forum", "https://forum.opengamingnetwork.com"]
];

export const appBarHeight = 44;
const useStyles = makeStyles(theme => ({
  root: {
    height: appBarHeight,
    flexGrow: 0,
    flexDirection: "row-reverse",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0.5, 1)
  },
  section: {
    flexGrow: 0,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center"
  },
  appName: {
    marginRight: theme.spacing(3)
  },
  spacer: {
    height: appBarHeight,
    minHeight: appBarHeight
  },
  mobileMenu: {
    position: "fixed",
    top: appBarHeight,
    left: 0,
    right: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    zIndex: theme.zIndex.modal,
    borderTop: "1px solid black",
    color: theme.palette.primary.contrastText,
    "& > *:not(:first-child):not(:last-child)": {
      marginBottom: theme.spacing(2)
    },
    "& > *:first-child": {
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(-1)
    },
    "& #user-menu-button": {
      marginLeft: theme.spacing(-1),
      marginTop: theme.spacing(-1)
    }
  }
}));

const AppBar = () => {
  const classes = useStyles();
  const [siteMenu, setSiteMenu] = useState(defaultSiteMenu);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [secondaryTopHeadings, setSecondaryTopHeadings] = useState(
    defaultSecondaryTopHeadings
  );

  const anchorRef = useRef(null);

  useEffect(() => {
    const getMenuExec = getMenuItems.run();
    getMenuExec.listen({
      onCancelled: () => {},
      onRejected: reason => {
        console.log(`rejected`, reason);
      },
      onResolved: data => {
        console.log(`resolved`, data);
        // There should be data.siteMenu and data.secondaryTopHeadings
        const { siteMenu, secondaryTopHeadings } = data;
        setSiteMenu(siteMenu);
        setSecondaryTopHeadings(secondaryTopHeadings);
      }
    });
  }, []);

  const topHeadingsItems = useMemo(
    () =>
      _.map(secondaryTopHeadings, (heading, index) => {
        const [label, href] = heading;
        return (
          <div key={index}>
            <Link
              target="_blank"
              href={href}
              underline="none"
              rel="noopener noreferrer"
              color="inherit"
              variant="body1"
            >
              {label}
            </Link>
          </div>
        );
      }),
    [secondaryTopHeadings]
  );

  return (
    <>
      <MUIAppBar
        ref={anchorRef}
        className={classes.root}
        id="wsh-AppBar"
        position="fixed"
      >
        <Hidden mdUp>
          <div className={classes.section}>
            <IconButton
              color="inherit"
              onClick={() => {
                setMobileMenuOpen(open => !open);
              }}
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Hidden>
        <Hidden smDown>
          <div className={classes.section}>
            <UserMenu anchorRef={anchorRef} />
          </div>
          <div className={classes.section}>
            <OGNMenu anchorRef={anchorRef} siteMenu={siteMenu} />
            <Typography className={classes.appName} variant="body1">
              Pocket Probability
            </Typography>
            {topHeadingsItems}
          </div>
        </Hidden>
      </MUIAppBar>
      <Hidden mdUp>
        <Grow in={mobileMenuOpen} style={{ transformOrigin: "top center" }}>
          <Box className={classes.mobileMenu} boxShadow={3}>
            <OGNMenu siteMenu={siteMenu} />
            <Typography className={classes.appName} variant="body1">
              Pocket Probability
            </Typography>
            {topHeadingsItems}
            <div>
              <UserMenu />
            </div>
          </Box>
        </Grow>
      </Hidden>
      <div className={classes.spacer}></div>
    </>
  );
};

export default AppBar;
